import React, { useEffect } from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { Icon } from '@ohif/ui';

import { useLogout, useProfile } from './helpers/api/auth/auth';
import { usePermissions } from './helpers/acl/permissions';


const ProtectedRoutes = ({ children, requiredPermissions }) => {
  const me = useProfile({ retry: 0 });
  const { can, isLoading: permsLoading } = usePermissions();
  const logoutMutation = useLogout();
  const location = useLocation();

  // Gate by the user's effective permission set. OR semantics; no requirement =
  // any signed-in user. Backend enforces regardless.
  const isAllowed = can(requiredPermissions);

  useEffect(() => {
    if (!me.isLoading && me.data && !permsLoading && !isAllowed && location.pathname === '/home') {
      console.error("Infinite redirect loop detected. Logging out user...");
      logoutMutation.mutate({});
    }
  }, [isAllowed, location.pathname, me.isLoading, me.data, permsLoading]);

  if (me?.isLoading || (me?.data && permsLoading)) {
    return (
      <div className="fixed inset-0 z-[100] flex h-full w-full flex-col items-center justify-center bg-card-color-100">
        <div className="loader">
          <Icon name={'deepechoLogo2'} />
        </div>
      </div>
    );
  }

  if (!me?.data) {
    return <Navigate to="/login" replace />;
  }

  if (!isAllowed) {
    if (location.pathname === '/home') {
      return null; 
    }

    return <Navigate to="/home" replace />;
  }

  if (me?.data?.force_2fa_setup_required && location.pathname !== '/2fa-setup') {
    return <Navigate to="/2fa-setup" replace />;
  }

  if (location.pathname === '/2fa-setup' && me?.data?.is_2fa_enabled) {
    return <Navigate to="/home" replace />;
  }

  return children;
};

export default ProtectedRoutes;